(function () {
  'use strict';

  const normalise = (value) => (value || '').replace(/\s+/g, ' ').trim().toUpperCase();

  const closestSection = (node) => node && (node.closest('.shopify-section') || node.closest('[id^="shopify-section"]'));

  const setText = (root, selector, text) => {
    const el = root && root.querySelector(selector);
    if (el) el.textContent = text;
    return el;
  };

  const editorialCopy = {
    lingerie: {
      subtitle: 'From barely there to beautifully bold, find the lingerie mood that suits you.',
      cards: {
        'CROTCHLESS LINGERIE': ['BARELY THERE', 'Daring cuts, sheer finishes and styles designed to reveal a little more.'],
        'LINGERIE SETS': ['PERFECTLY PAIRED', 'Coordinated lace, straps and statement details made to be worn together.'],
        'HOLD UPS & STOCKINGS': ['THE FINISHING TOUCH', 'Hold-ups, stockings and hosiery that complete the look beautifully.'],
        'BODYSTOCKINGS': ['SECOND-SKIN SEDUCTION', 'Fishnet, lace and curve-hugging styles from neckline to toe.']
      }
    },
    more: {
      subtitle: 'Beyond lingerie, discover beauty, fragrance, gifts and the newest arrivals.',
      cards: {
        'NEW LINGERIE': ['JUST LANDED', 'Fresh arrivals and new reasons to refresh the lingerie drawer.'],
        'BEAUTY': ['BEAUTY WORTH KNOWING', 'Skincare, makeup and body care worthy of a place on your shelf.'],
        'PERFUME & COLOGNE': ['SIGNATURE SCENTS', 'Cult favourites, modern icons and fragrances made to be remembered.'],
        'GIFTS': ['LITTLE LUXURIES', 'Thoughtful treats, indulgent extras and gifts worth unwrapping.']
      }
    }
  };

  function enhanceEditorial(section, variant) {
    if (!section || section.dataset.oslEditorialReady === 'true') return;
    section.dataset.oslEditorialReady = 'true';
    section.classList.add('osl-home-editorial', `osl-home-editorial--${variant}`);

    const config = editorialCopy[variant];
    const subtitle = section.querySelector('.sec-ttl .sbttl');
    if (subtitle) subtitle.textContent = config.subtitle;

    section.querySelectorAll('.cl_item').forEach((card) => {
      const title = card.querySelector('.cl_ttl');
      const details = card.querySelector('.details');
      if (!title || !details) return;

      const key = normalise(title.textContent).replace('HOLD-UPS', 'HOLD UPS');
      const copy = config.cards[key];
      if (!copy) return;

      card.classList.add('osl-editorial-card');
      if (!details.querySelector('.osl-editorial-kicker')) {
        const kicker = document.createElement('span');
        kicker.className = 'osl-editorial-kicker';
        kicker.textContent = copy[0];
        details.insertBefore(kicker, title);
      }
      if (!details.querySelector('.osl-editorial-copy')) {
        const body = document.createElement('p');
        body.className = 'osl-editorial-copy';
        body.textContent = copy[1];
        title.insertAdjacentElement('afterend', body);
      }
    });
  }

  function replaceLegacyTrust() {
    const titles = Array.from(document.querySelectorAll('.bl_ttl'));
    const marker = titles.find((el) => normalise(el.textContent) === 'REAL PERSON SUPPORT');
    const section = closestSection(marker);
    if (!section || section.dataset.oslHelpReady === 'true') return;

    section.dataset.oslHelpReady = 'true';
    section.className = `${section.className} osl-home-help-section`;
    section.innerHTML = `
      <section class="osl-home-help" aria-labelledby="osl-home-help-title">
        <div class="osl-home-help__inner">
          <p class="osl-home-help__eyebrow">HERE WHEN YOU NEED US</p>
          <h2 id="osl-home-help-title">A LITTLE HELP, BEAUTIFULLY SIMPLE</h2>
          <p class="osl-home-help__lead">From fit and delivery to returns and product authenticity, find the details you need before you order.</p>
          <div class="osl-home-help__links">
            <a href="/pages/size-guide"><span>SIZE &amp; FIT</span><small>Find your best fit</small></a>
            <a href="/pages/delivery-information"><span>DELIVERY</span><small>UK delivery information</small></a>
            <a href="/pages/returns-and-refunds"><span>RETURNS</span><small>Clear, customer-friendly guidance</small></a>
            <a href="/pages/fragrance-sourcing-authenticity"><span>AUTHENTICITY</span><small>How we source beauty &amp; fragrance</small></a>
          </div>
          <p class="osl-home-help__contact">Still need a hand? <a href="/pages/contact-us">Contact Oh So Luxe</a>.</p>
        </div>
      </section>`;
  }

  function updateCopyAndClasses() {
    const hero = document.querySelector('.slideshow .swiper-slide');
    if (hero) {
      setText(hero, '.hd3', 'Irresistible lingerie. Iconic fragrance. Beauty worth obsessing over.');
    }

    const moodSection = document.querySelector('.osl-shop-your-mood-section');
    if (moodSection) {
      const moodCards = Array.from(moodSection.querySelectorAll('.osl-mood-card'));
      moodCards.forEach((card) => {
        const title = normalise(card.querySelector('.osl-mood-card__title')?.textContent);
        const text = card.querySelector('.osl-mood-card__text');
        if (!text) return;
        if (title === 'AFTER DARK') text.textContent = 'BDSM, fetish and provocative lingerie for nights that call for something bolder.';
        if (title === 'BARELY THERE') text.textContent = 'Crotchless, sheer and barely-there styles designed to reveal a little more.';
        if (title === 'SOFT & ROMANTIC') text.textContent = 'Blush tones, delicate lace and softer silhouettes with a beautifully feminine edge.';
        if (title === 'SIGNATURE SCENT' || title === 'MAIN CHARACTER') {
          const titleEl = card.querySelector('.osl-mood-card__title');
          if (titleEl) titleEl.textContent = 'Signature Scent';
          text.textContent = 'Iconic fragrance with the kind of presence people remember.';
        }
      });
    }

    const curated = document.querySelector('.osl-curated-products-section');
    if (curated) {
      setText(curated, '.osl-curated__eyebrow', 'THE OH SO LUXE EDIT');
      setText(curated, '.osl-curated__header h2', 'LINGERIE TO LUST AFTER');
      setText(curated, '.osl-curated__subtitle', 'Standout sets, irresistible details and the pieces we think deserve your attention.');
      setText(curated, '.osl-curated__cta', 'SHOP LINGERIE SETS');
    }

    const brands = document.querySelector('.osl-luxury-brands-section');
    if (brands) {
      setText(brands, '.osl-luxury-brands__heading', 'ICONIC BEAUTY & FRAGRANCE BRANDS');
      setText(brands, '.osl-luxury-brands__text', 'Discover cult favourites, signature scents and beauty icons from names worth knowing.');
    }

    const luxeList = document.querySelector('.osl-luxe-list-section');
    if (luxeList) {
      const lead = luxeList.querySelector('.osl-luxe-list__lead');
      if (lead) lead.innerHTML = 'Enjoy <strong>5% off your first eligible order</strong>, plus first access to new arrivals, restocks and private offers.';
      setText(luxeList, '.osl-luxe-list__success', 'You’re on the list. Check your inbox for your 5% welcome offer.');
      setText(luxeList, '.osl-luxe-list__fine', '5% welcome offer applies to eligible non-fragrance products. Unsubscribe anytime.');
    }

    const social = document.querySelector('.osl-social-cta-section');
    if (social) {
      setText(social, '.osl-social-cta__text', 'New arrivals, lingerie inspiration, fragrance finds and beauty worth knowing about.');
    }

    document.querySelectorAll('.shopify-section, [id^="shopify-section"]').forEach((section) => {
      const heading = section.querySelector('.sec-ttl .sttl');
      const title = normalise(heading?.textContent);
      if (title === 'THE LINGERIE EDIT') enhanceEditorial(section, 'lingerie');
      if (title === 'MORE TO LOVE') enhanceEditorial(section, 'more');
      if (title === 'THE LUXE EDIT') {
        section.classList.add('osl-home-blog');
        const subtitle = section.querySelector('.sec-ttl .sbttl');
        if (subtitle) subtitle.textContent = 'Practical guides, curated edits and useful advice on lingerie, fragrance and beauty.';
      }
    });

    replaceLegacyTrust();
  }

  function init() {
    updateCopyAndClasses();
    window.setTimeout(updateCopyAndClasses, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
